import React from 'react';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { routes } from '../../routes';
import { STATIC_RESOURCES_ROOT } from '../../constants';
import { LOCALES, DEFAULT_LOCALE } from '../../constants/locale';

import {
    registerAdBlockerDetection,
    registerCookieDetection
} from '../../services/adblocker/actions';
import { fetchEbonPartners } from '../../services/ebon/actions';
import { changeCurrentLocale } from '../../services/i18n/actions';
import { fetchPartnersIfNeeded } from '../../services/partner/actions';
import { fetchCategoriesIfNeeded } from '../../services/category/actions';

import { mapRoutes } from '../../utils/routeUtils';
import { getLocaleFromRoutes } from '../../services/i18n/utils';

const ConnectedSwitch = connect(state => ({
    location: state.location
}))(Switch);

class RouterComponent extends React.Component {
    componentWillMount() {
        this.changeCurrentLocaleIfNeeded(this.props);

        this.detectAdBlocker();
        this.checkCookies();
    }

    componentDidMount() {
        const { fetchPartnersIfNeeded, fetchCategoriesIfNeeded, fetchEbonPartners } = this.props;

        fetchPartnersIfNeeded();
        fetchCategoriesIfNeeded();
        fetchEbonPartners();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.changeCurrentLocaleIfNeeded(nextProps);
        }
    }

    changeCurrentLocaleIfNeeded({ pathname, currentLocale }) {
        // On vient mettre à jour le store si on arrive avec une url d'un autre langage
        const newLocale = getLocaleFromRoutes(pathname, LOCALES, DEFAULT_LOCALE);

        if (newLocale !== currentLocale) {
            this.props.changeCurrentLocale(newLocale);
            moment.locale(newLocale);
        }
    }

    detectAdBlocker() {
        const { registerAdBlockerDetection } = this.props;

        const head = document.getElementsByTagName('head')[0];

        const noAdBlockDetected = () => {
            registerAdBlockerDetection(false);
        };
        const adBlockDetected = () => {
            registerAdBlockerDetection(true);
        };

        // we will dynamically generate some 'bait'.
        const script = document.createElement('script');
        script.id = 'adblock-detection';
        script.type = 'text/javascript';
        script.src = `${STATIC_RESOURCES_ROOT}/scripts/adframe.js`;
        script.onload = noAdBlockDetected;
        script.onerror = adBlockDetected;

        head.appendChild(script);

        // clean up stale bait
        const oldScript = document.getElementById('adblock-detection');
        if (oldScript) {
            head.removeChild(oldScript);
        }
    }

    checkCookies() {
        const { registerCookieDetection } = this.props;

        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }

        registerCookieDetection(cookieEnabled);
    }

    render() {
        return <ConnectedSwitch>{mapRoutes(routes)}</ConnectedSwitch>;
    }
}

const mapStateToProps = state => {
    return {
        pathname: state.routing.location.pathname,
        locale: state.i18n.locale,
        isAuthed: !isEmpty(state.authentication.token)
    };
};
const mapDispatchToProps = {
    fetchPartnersIfNeeded,
    fetchCategoriesIfNeeded,
    fetchEbonPartners,
    changeCurrentLocale,
    registerAdBlockerDetection,
    registerCookieDetection
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterComponent);



// WEBPACK FOOTER //
// ./src/components/router/RouterComponent.js